var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.9,38.5L389,163.4H305v131h-97.2v-131h-85L255.9,38.5 M495.4,334.3c6.1,3.4,10.7,8.9,13.8,16.4 c3.1,7.5,3.6,14.3,1.5,20.5L496.4,450c-1.4,6.8-5.1,12.5-11.3,16.9c-6.1,4.4-13,6.7-20.5,6.7H47c-7.5,0-14.3-2.2-20.5-6.7 s-9.9-10.1-11.3-16.9L1,371.2c-3.4-16.4,2-28.7,16.4-36.9L98.2,279h50.2l-87,66.5h91.1c2.7,0,4.8,1.4,6.1,4.1l20.5,56.3h153.6 l20.5-56.3c2.7-2.7,4.8-4.1,6.1-4.1h91.1l-87-66.5h50.2L495.4,334.3"
  }))));
};
export default SvgUpload;